import React ,  {useEffect, useState}from 'react'
import { Button, Form ,TextArea, Image, Divider} from 'semantic-ui-react';
import { Field, useFormik } from 'formik';
import * as Yup from "yup";
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { PUBLIC_COMPLET } from '../../../../gql/publication';
import captura from "../../../../asets/png/market.png"
//import Preview from '../../Publications/PreviewPublication./Preview';
//import "./Title.scss";
//import usePublic from '../../../hooks/usePublic';



export default function Promo (props) {
const  { publication , setShowModal } = props;
const [completPublic] = useMutation (PUBLIC_COMPLET);
const desk = publication.description


console.log(publication)

console.log (publication._id)



const formik = useFormik ({
  initialValues:initialValue(),


  validationSchema:Yup.object({
   
    market:Yup.string().required()
    

  }),


  onSubmit: async (formv) => {try
    { const formData= formv;
      console.log(formv);

       await completPublic({
        variables:{
          input:{
            idPublication:publication._id,
            market:formData.market,
            
          },
          },}
      );
      toast.success (" Publicacion vinculada 😁 ");

      setTimeout(() =>  setShowModal (false),3000);


      
}    catch (error) {
      toast.error(error.message);
      console.log (error)
      console.log (formv)
    }
  },

 });





  return (
    
        <Form  onSubmit = {formik.handleSubmit} className= "mosset">
        <h2> Click en compartir, copiar enlace  y pegalo en el campo  </h2>
        <Image   src= { captura} centered />
        <Divider/>
          
   <h2> Enlace  </h2>
         <Form.Input type= "Text" placeholder = "https://www.facebook.com/share/12ETcMheE45/"
         name= "market"  
         value = {formik.values.market}
        onChange = {formik.handleChange}
        error={formik.errors.market && true}

      />

      <Button type= "submit" className=' btn-submit'>  * Publicar * </Button> 

        </Form>
    
  )
}
function initialValue() {
  return  {
    "idPublication": "",
    "market": "",  
  };
};
